import qs from "qs";

export default (search = window.location.search) => {
    return qs.parse(search, {ignoreQueryPrefix: true}) || {}
}
